<template>
  <div v-if="global.selectedAppTab == 3">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" class="px-0 pt-0 border-right">
                <v-subheader>Présentation</v-subheader>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>Basic</v-list-item-title>
                    <v-list-item-subtitle>
                      <div
                        v-if="
                          clientPortal.portalConfiguration.basic_presentation !=
                            null &&
                          clientPortal.portalConfiguration.basic_presentation
                            .access != null &&
                          clientPortal.portalConfiguration.basic_presentation
                            .access.length > 0
                        "
                      >
                        {{
                          clientPortal.portalConfiguration.basic_presentation.access
                            .toString()
                            .toUpperCase()
                        }}
                        ({{
                          clientPortal.portalConfiguration.basic_presentation
                            .payment
                        }})
                      </div>
                      <div v-else>-</div>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Full</v-list-item-title>
                    <v-list-item-subtitle>
                      <div
                        v-if="
                          clientPortal.portalConfiguration.full_presentation !=
                            null &&
                          clientPortal.portalConfiguration.full_presentation
                            .access != null &&
                          clientPortal.portalConfiguration.full_presentation
                            .access.length > 0
                        "
                      >
                        {{
                          clientPortal.portalConfiguration.full_presentation.access
                            .toString()
                            .toUpperCase()
                        }}
                        ({{
                          clientPortal.portalConfiguration.full_presentation
                            .payment
                        }})
                      </div>
                      <div v-else>-</div>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" md="4" class="px-0 pt-0 border-right">
                <v-subheader>Profil</v-subheader>
                <portal-options-summary-card
                  v-if="!clientPortal.isInherit && !clientPortal.isBuiltin"
                  :partner="clientPortal.partner"
                  :portal-options.sync="clientPortal.portalOptions"
                  :is-readonly="!isGrantedUser()"
                ></portal-options-summary-card>
                <div v-else-if="clientPortal.isInherit" class="px-3">
                  Configuration hérité du groupe.
                  <portal-options-summary-card
                    :partner="clientPortal.partner"
                    :portal-options.sync="clientPortal.group.portalOptions"
                    :is-readonly="true"
                  ></portal-options-summary-card>
                </div>
                <div v-else-if="clientPortal.isBuiltin" class="px-3">
                  Configuration du Template prédéfini.
                  <portal-options-summary-card
                    :partner="clientPortal.partner"
                    :portal-options.sync="clientPortal.portalOptions"
                    :is-readonly="true"
                  ></portal-options-summary-card>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="pr-0 pt-0">
                <v-subheader>Général</v-subheader>
                <switch-confirm
                  :value.sync="clientPortal.useGroupCatalog"
                  label="Utiliser le catalogue du groupe"
                  v-on:confirm="updatePortal(clientPortal.id)"
                  :loading="isLoading"
                  :dense="true"
                  :disabled="!clientPortal.group || !isGrantedUser()"
                  color="black"
                >
                  <template #confirm-text>
                    Êtes-vous sûr.e de vouloir
                    {{
                      !clientPortal.useGroupCatalog ? "désactiver" : "activer"
                    }}
                    l'utilisation du catalogue du groupe ?
                  </template>
                </switch-confirm>
                <switch-confirm
                  :value.sync="clientPortal.hasMacLocking"
                  label="Activer le blocage MAC"
                  v-on:confirm="updatePortal(clientPortal.id)"
                  :loading="isLoading"
                  :dense="true"
                  color="black"
                  :disabled="!isGrantedUser()"
                >
                  <template #confirm-text>
                    Êtes-vous sûr.e de vouloir
                    {{ !clientPortal.hasMacLocking ? "désactiver" : "activer" }}
                    le blocage MAC sur ce portail ?
                  </template>
                </switch-confirm>
                <switch-confirm
                  :value.sync="clientPortal.isSandboxModeActive"
                  label="Activer le mode Sandbox"
                  v-on:confirm="updatePortal(clientPortal.id)"
                  :loading="isLoading"
                  :dense="true"
                  color="orange"
                  :disabled="!isGrantedUser()"
                >
                  <template #confirm-text>
                    Êtes-vous sûr.e de vouloir
                    {{
                      !clientPortal.isSandboxModeActive
                        ? "désactiver"
                        : "activer"
                    }}
                    le mode Sandbox sur ce portail ?
                  </template>
                </switch-confirm>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <catalog-card
      :clientPortal="clientPortal"
      :refreshCatalogs="refreshCatalogs"
    ></catalog-card>
    <mac-adress-card :clientPortal="clientPortal"></mac-adress-card>
  </div>
</template>
<script>
import { defineComponent, ref, toRefs } from "@vue/composition-api";
import global from "@/composables/global";
import { useClientPortal } from "@/composables/client-portal";
import SwitchConfirm from "@/components/General/SwitchConfirm.vue";
import PortalOptionsSummaryCard from "@/components/PortalOptions/PortalOptionsSummaryCard.vue";
import CatalogCard from "@/components/ClientPortal/CatalogCard";
import MacAdressCard from "@/components/ClientPortal/MacAdressCard";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    SwitchConfirm,
    PortalOptionsSummaryCard,
    CatalogCard,
    MacAdressCard,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* import des API */
    const { data, updateClientPortal } = useClientPortal();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const refreshCatalogs = ref(false);

    const updatePortal = async function (idPortal) {
      const formData = {
        passmanId: props.clientPortal.passmanId,
        description: props.clientPortal.description,
        group: props.clientPortal.group ? props.clientPortal.group.id : null,
        isActive: props.clientPortal.isActive,
        useGroupCatalog: props.clientPortal.useGroupCatalog,
        isSandboxModeActive: props.clientPortal.isSandboxModeActive,
        cardPrefix: props.clientPortal.cardPrefix,
        hasMacLocking: props.clientPortal.hasMacLocking,
        proxyNumber: props.clientPortal.proxyNumber,
      };
      Object.assign(data.clientPortalForm, formData);
      refreshCatalogs.value = true;
      await updateClientPortal(idPortal);
      refreshCatalogs.value = false;
    };

    return {
      updatePortal,
      refreshCatalogs,
      global,
      ...toRefs(data),
      isGrantedUser,
    };
  },
});
</script>
